module.exports = __webpack_public_path__ + "img/calendar.9bd0155c.svg";